// ----------------------------------------------------------------------------- //
//  Projects filters
// ----------------------------------------------------------------------------- //
document.addEventListener('DOMContentLoaded', function () {

    const filterButtons = document.querySelectorAll('.projects__button');
    const projectItems = document.querySelectorAll('.projects__item');

    if(filterButtons.length && projectItems.length){
        // Add 'aria-expanded' attribute to the first filter button by default
        filterButtons[0].setAttribute('aria-expanded', 'true');

        filterButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                // Remove 'aria-expanded' attribute from all filter buttons
                filterButtons.forEach(function (btn) {
                    btn.setAttribute('aria-expanded', 'false');
                });

                // Set 'aria-expanded' attribute to 'true' for the clicked button
                button.setAttribute('aria-expanded', 'true');

                const filterValue = button.getAttribute('data-filter');

                projectItems.forEach(function (item) {
                    const categories = item.classList;

                    if (filterValue === 'all' || categories.contains(filterValue)) {
                        // Show items with transition
                        item.classList.remove('hidden');
                    } else {
                        // Hide items with transition
                        item.classList.add('hidden');
                    }
                });
            });
        });
    }

});

